<template>
  <div style="height: 100%;">
    <el-col :span="isRadio ? 12 : 7" style="height:100%;overflow-y:auto">
      <mw-tree :url="deptTreeUrl" :async="true" :multiple="false" ref="aa" :defaultParams="defaultParams"
               :expandedFirst="true" :selectFirst="true" :selectNode="selectedDept" aliasId="departmentId" @changed="generateData"></mw-tree>
    </el-col>
    <el-col :span="isRadio ? 12 :17" style="height:100%;">
      <el-col :span='hxSpan' style="height:100%;overflow-y:auto">
        <el-table
          :data="LAdminData"
          :row-class-name="tableRowClassName"
          ref="adminData"
          @row-click="handleRow"
          @selection-change="handleLSelectionChange">
          <el-table-column
            v-if="!isRadio"
            type="selection"
            width="30">
          </el-table-column>
          <el-table-column v-if="isRadio" width="30" type=''>
            <template v-if="isRadio" slot-scope="props">
              <el-radio v-if="isRadio" class="radio" v-model="index" :label="props.row.index">{{&nbsp;}}</el-radio>
            </template></el-table-column>
          <el-table-column
            width="55"
            type="index">
          </el-table-column>
          <el-table-column
            prop="name"
            label="名称">
          </el-table-column>
        </el-table>
      </el-col>
      <el-col  :offset='1' :span='2' class="loadManager-button"  style="margin-top: calc(50% - 180px);" v-if="!isRadio">
        <el-button v-if="!isRadio" @click="handleChange('LeftAll')"><i class="fa fa-angle-double-right"></i></el-button>
        <el-button @click="handleChange('LeftChecked')"><i class="fa fa-angle-right"></i></el-button>
        <el-button v-if="!isRadio" @click="handleChange('RightAll')"><i class="fa fa-angle-double-left"></i></el-button>
        <el-button @click="handleChange('RightChecked')"><i class="fa fa-angle-left"></i></el-button>
      </el-col>
      <el-col :offset='1' :span='yxSpan' style="height:100%;overflow-y:auto" v-if="!isRadio">
        <template>
          <el-table
            :data="RAdminData"
            ref="adminRData"
            @row-click="handleRowR"
            @selection-change="handleRSelectionChange">
            <el-table-column
              type="selection"
              width="30">
            </el-table-column>
            <el-table-column
              width="40"
              type="index">
            </el-table-column>
            <el-table-column
              prop="name"
              label="名称">
            </el-table-column>
          </el-table>
        </template>
      </el-col>
    </el-col>
  </div>
</template>
<script>

  export default {
    props: {
      RAdminData: {
        type: Array,
        default: function () {
          return [];
        }
      },
      defaultParentId:{
        type: String,
        default: ''
      },
      listAble: {
        type:Boolean,
        default:false
      },
      isRadio:{
        type:Boolean,
        default:false
      },
      isAppendDepartment:{
        type:Boolean,
        default:false
      }
    },
    data() {
      let hxSpan = this.isRadio ? 24 : this.isAppendDepartment ? 7 : 10;
      let yxSpan = this.isAppendDepartment ? 13 : 10;
      return {
        defaultParams:{rootId:this.defaultParentId, listAble:this.listAble},
        deptTreeUrl: this.mwUrl('/api/org/getDepartmentTree'),
        selectedDept: '',
        LAdminData: [],
        hxSpan:hxSpan,
        yxSpan:yxSpan,
        multipleLSelection: [],
        multipleRSelection: [],
        b: false,
        index:-1
      }
    },

    methods: {
      tableRowClassName(row){
        row.row.index=row.rowIndex;
      },
      handleRowR(row) {
        this.mwRef('adminRData').toggleRowSelection(row);
      },
      handleRow(row) {
        if(!this.isRadio){
          this.mwRef('adminData').toggleRowSelection(row);
        }else{
          this.index=row.index;
          this.multipleLSelection = [];
          this.multipleLSelection.push(row);
        }
      },

      handleLSelectionChange(val) {
        this.multipleLSelection = val;
      },
      handleRSelectionChange(val) {
        this.multipleRSelection = val;
      },

      // 加载管理员
      generateData(data) {

        let me = this;
        me.loading = true;
        me.selectedDept = data.id;
        this.mwApi.org.listUser({departmentId :data.id}).then(data => {
          if (data.success) {
              me.index=-1;
              me.multipleLSelection=[];
            if (me.RAdminData.length != 0) {

              me.LAdminData = data.result;

              me.RAdminData.forEach((r) => {
                data.result.forEach((t, index) => {
                  if (r.identityId === t.identityId) {
                    me.LAdminData.splice(index, 1);
                    return;
                  }
                });
              })
            } else {
              me.LAdminData = data.result;
            }

          }

        });
      },
      // 穿梭框的操作
      handleChange(data) {
        let me = this;
        //把右边表格的全部数据放到左边表格
        if (data === 'RightAll') {
          this.RAdminData.forEach((t, index) => {
            if (t.departmentId === this.selectedDept) {
              t.name = this.getUserName(t.name,t.srcName);
              me.LAdminData.push(t);
            }
          })
          this.RAdminData.splice(0, this.RAdminData.length)
        }
        //把右边表格的选中的数据放到左边表格
        if (data === 'RightChecked') {
          if (this.multipleRSelection.length == 0) {
            this.mwMsg('info','请选择你要操作的数据');
          } else {
            this.multipleRSelection.forEach(t => {
              if (t.departmentId === this.selectedDept) {
                t.name = this.getUserName(t.name,t.srcName);
                me.LAdminData.push(t);
              }
              me.RAdminData.forEach(function (key, index) {
                if (key.identityId === t.identityId) {
                  me.RAdminData.splice(index, 1);
                }
              });
            })
            me.LAdminData.sort(function(val1,val2){
              if(val1.sn>val2.sn){
                return 1
              }
              if(val1.sn<val2.sn){
                return -1;
              }
              if(val1.sn==val2.sn){
                return 0;
              }
            })
          }
        }
        let fullDeptName = this.getFullDepartmentName();
        //把左边表格的全部数据放到右边表格
        if (data === 'LeftAll') {

          this.LAdminData.forEach((t, index) => {
            if(me.isAppendDepartment){
              t.srcName = t.name;
              t.name = t.name+"("+fullDeptName+")"
            }
            me.RAdminData.push(t);
          });
          this.LAdminData.splice(0, this.LAdminData.length)
        }

        //把左边表格的选中数据放到右边表格
        if (data === 'LeftChecked') {
          if (this.multipleLSelection.length == 0) {
            this.mwMsg('info','请选择你要操作的数据' );
          } else {

            if(this.isRadio){
              this.index=-1;
              this.multipleLSelection.forEach(t=>{
                if(me.RAdminData.length==0){
                  me.RAdminData.push(t);
                }else{
                  var r=me.RAdminData.shift();
                  if(me.LAdminData.length>0&&r.departmentId==me.LAdminData[0].departmentId){
                    me.LAdminData.push(r);
                  }
                  me.RAdminData.push(t);
                }
                me.LAdminData.forEach(function (key, index) {
                  if (key.identityId === t.identityId) {
                    me.LAdminData.splice(index, 1);
                  }
                })
              })
              this.multipleLSelection=[];
              me.LAdminData.sort(function(val1,val2){
                if(val1.sn>val2.sn){
                  return 1
                }
                if(val1.sn<val2.sn){
                  return -1;
                }
                if(val1.sn==val2.sn){
                  return 0;
                }
              })
            }else{
              this.multipleLSelection.forEach(t => {
                if(me.isAppendDepartment){
                  t.srcName = t.name;
                  t.name = t.name+"("+fullDeptName+")"
                }
                me.RAdminData.push(t);
                me.LAdminData.forEach(function (key, index) {
                  if (key.identityId === t.identityId) {
                    me.LAdminData.splice(index, 1);
                  }
                })
              })
            }
          }
        }
      },
      getUserName(name,srcName){
        if(this.isAppendDepartment){
          if(srcName){
            return srcName;
          }
          var pos =name.lastIndexOf("(");
          if(pos != -1){
            return name.substring(0,pos);
          }
        }
        return name || "";
      },
      getFullDepartmentName(){
        let me = this;
        if(!me.isAppendDepartment) return "";
        let tree = me.$refs.aa;
        let ret = [];
        if(tree){
          let nodeData = tree.getSelected();
          let node = tree.getNode(nodeData.id)
          while (node ){
            ret.push(node.original.shortname || node.original.name);
            if(node.parent && node.parent != "#"){
              node = tree.getNode(node.parent)
            }else{
              node = undefined;
            }
          }
        }
        return ret.reverse().join("/");
      },
// 根据b是否为true，判断是否要刷树
      refreshTree(a) {
        if (a) {
          this.b = true;
        }
      },
      getValue() {
        if(this.isRadio){
          return this.multipleLSelection;
        }else{
          return this.RAdminData;
        }
      }
    },

    watch: {
      RAdminData: {
        handler: function (val) {
          if (this.b) {
            this.mwRef('aa').refresh();
            this.b = false;
          }
        }
      },
      defaultParentId(val){
        this.defaultParams={rootId:this.defaultParentId, listAble:this.listAble};
      }
    }

  }
</script>
<style scoped>
  .loadManager-button .el-button{
    width:50px;
    margin-top:40px;
  }
  .loadManager-button .el-button+.el-button {
    margin-top:10px;
    margin-left: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/org/user/loadManager.vue